<template>
  <b-overlay :show="itemBusy" variant="transparent">
    <b-card>
      <div class="row">
        <div class="col-lg-6 col-12">
          <label>Search</label>
          <input
            v-model="search"
            type="text"
            class="form-control"
            placeholder="Organization name or email"
            @keyup.enter="filterOrgs()"
          >
        </div>
        <div class="col-lg-3 col-12 pt-2" @click="filterOrgs()">
          <span class="btn btn-primary">
            <feather-icon icon="SearchIcon" /> Search
          </span>
        </div>
      </div>
    </b-card>

    <b-card>
      <p v-if="loadError" class="text-danger">{{ loadError }}</p>
      <b-table
        class="rounded border"
        :items="items"
        :fields="fields"
        responsive
        show-empty
        empty-text="No organizations yet."
      >
        <template #head()="scope">
          <div class="text-nowrap text-primary">{{ scope.label }}</div>
        </template>
        <template #cell(name)="data">
          <div v-if="data.item.id" class="pt-1">
            <div class="font-weight-bolder">{{ data.item.name }}</div>
            <div class="text-muted small">{{ data.item.email || data.item.slug }}</div>
          </div>
        </template>
        <template #cell(events)="data">
          <span v-if="data.item.id">
            {{ data.item.eventCount }}
            <span class="text-muted">· {{ data.item.publishedCount }} public</span>
            <div v-if="data.item.hiddenCount" class="text-danger small">
              {{ data.item.hiddenCount }} hidden by staff
            </div>
          </span>
        </template>
        <template #cell(ticketsSold)="data">
          <span v-if="data.item.id" class="font-weight-bolder">{{ data.item.ticketsSold }}</span>
        </template>
        <template #cell(revenue)="data">
          <span v-if="data.item.id">{{ moneyList(data.item.byCurrency) }}</span>
        </template>
        <template #cell(createdAt)="data">
          <span v-if="data.item.id" class="text-nowrap">
            {{ dayjs(data.item.createdAt).format('MMM D, YYYY') }}
          </span>
        </template>
        <template #cell(actions)="data">
          <b-button
            v-if="data.item.id"
            size="sm"
            variant="outline-primary"
            :to="{ name: 'tickets-events', query: { org: data.item.name } }"
          >
            View events
          </b-button>
        </template>
      </b-table>

      <div class="d-flex p-1">
        <div class="w-100">
          Page <span class="text-primary">{{ currentPage }}</span> of
          <span class="text-primary">{{ pageCount }}</span>
        </div>
        <div class="w-100">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="pageSize"
            align="right"
            size="sm"
            class="my-0"
            @page-click="loadNewPage"
          />
        </div>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import dayjs from 'dayjs'
import API from './api'
import { moneyList } from './format'

export default {
  name: 'TicketOrganizations',
  data() {
    return {
      dayjs,
      moneyList,
      search: '',
      items: [],
      currentPage: 1,
      totalRows: 0,
      pageSize: 10,
      itemBusy: false,
      loadError: '',
      fields: [
        { key: 'name', label: 'Organization' },
        { key: 'country', label: 'Country' },
        { key: 'events', label: 'Events' },
        { key: 'ticketsSold', label: 'Tickets sold' },
        { key: 'revenue', label: 'Revenue' },
        { key: 'createdAt', label: 'Joined' },
        { key: 'actions', label: '' },
      ],
    }
  },
  computed: {
    pageCount() {
      return Math.max(1, Math.ceil(this.totalRows / this.pageSize))
    },
  },
  created() {
    this.getOrganizations(1)
  },
  methods: {
    loadNewPage(event, page) {
      event.preventDefault()
      this.getOrganizations(page)
    },
    filterOrgs() {
      this.getOrganizations(1)
    },
    getOrganizations(page = 1) {
      this.itemBusy = true
      this.loadError = ''
      API.listOrganizations({
        q: this.search || undefined,
        page,
        pageSize: this.pageSize,
      }).then(res => {
        this.itemBusy = false
        if (res && res.success && res.data) {
          this.currentPage = res.data.page || page
          this.totalRows = res.data.total || 0
          this.pageSize = res.data.pageSize || this.pageSize
          this.items = res.data.list || []
          return
        }
        this.items = []
        this.loadError = (res && res.errorMsg) || 'Could not load organizations.'
      }).catch(() => {
        this.itemBusy = false
        this.loadError = 'Could not load organizations.'
      })
    },
  },
}
</script>
